import script from "./AccountTypeGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountTypeGrid.vue?vue&type=script&setup=true&lang=ts"

import "./AccountTypeGrid.vue?vue&type=style&index=0&id=73ff7155&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ff7155"]])

export default __exports__